import api from '../../services/api'

export default {
  namespaced: true,

  state: () => ({
    phases: [],
    currentPhase: null,
    loading: false,
    error: null
  }),

  mutations: {
    SET_PHASES(state, phases) {
      state.phases = phases
    },
    SET_CURRENT_PHASE(state, phase) {
      state.currentPhase = phase
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },

  actions: {
    async fetchPhases({ commit, rootGetters }) {
      const clientId = rootGetters['clients/selectedClientId']
      if (!clientId) {
        commit('SET_PHASES', [])
        return []
      }

      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const response = await api.get('/phases', { params: { clientId } })
        commit('SET_PHASES', response.data.data.phases)
        return response.data.data.phases
      } catch (error) {
        const message = error.response?.data?.error || 'Failed to fetch phases'
        commit('SET_ERROR', message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async fetchPhase({ commit }, phaseId) {
      commit('SET_LOADING', true)
      try {
        const response = await api.get(`/phases/${phaseId}`)
        commit('SET_CURRENT_PHASE', response.data.data.phase)
        return response.data.data.phase
      } catch (error) {
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    clearPhases({ commit }) {
      commit('SET_PHASES', [])
      commit('SET_CURRENT_PHASE', null)
    }
  },

  getters: {
    allPhases: (state) => state.phases,
    currentPhase: (state) => state.currentPhase,
    loading: (state) => state.loading,
    error: (state) => state.error,
    phasesByStatus: (state) => (status) => {
      return state.phases.filter(p => p.status === status)
    }
  }
}
